import React from 'react'
import { AuthProvider, UIProvider } from '@kuow/shared-ui'
import { portalTheme } from '../themes/portal-theme'
import { CoveSupportProvider } from '../support/CoveSupportProvider'

export const PortalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <UIProvider system={portalTheme} colorModeProviderProps={{ forcedTheme: 'light' }}>
      <AuthProvider>
        <CoveSupportProvider>{children}</CoveSupportProvider>
      </AuthProvider>
    </UIProvider>
  )
}
